<template>
  <div class="bg-primary">
    <!-- Header -->
    <div class="header bg-gradient-blue py-7 py-lg-6 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-5">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">
                <span v-if="rememberedFirstName"
                  >Welcome back, {{ rememberedFirstName }}!</span
                >
                <span v-else>Welcome back!</span>
              </h1>
              <p class="text-lead text-white">
                Please log in using the form below.
                <b-btn
                  variant="link"
                  v-if="rememberedFirstName"
                  @click="forgetAuth"
                  >Not {{ rememberedFirstName }}?</b-btn
                >
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-primary" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Log in using email address and password</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(login)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    :debounce="500"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email address"
                    v-model="model.email"
                  ></base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true }"
                    :debounce="500"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  ></base-input>

                  <b-form-checkbox v-model="model.staySignedIn"
                    >Stay logged in</b-form-checkbox
                  >

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-block"
                    >
                      <span v-if="!loggingIn">
                        Log in
                        <i class="fa fa-arrow-right ml-2"></i>
                      </span>
                      <span v-else>
                        Please wait&hellip;
                        <i class="fa fa-spin fa-spinner ml-2"></i>
                      </span>
                    </base-button>
                  </div>

                  <base-alert
                    v-if="errorMessage"
                    :dismissible="false"
                    type="default"
                    icon="fas fa-exclamation-circle"
                    >Error: {{ errorMessage }}</base-alert
                  >
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/forgot-password" class="text-light">
                <small>Forgot password?</small>
              </router-link>
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light">
                <small>Create new account</small>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
        staySignedIn: true // by default
      },
      loggingIn: false,
      errorMessage: null
    };
  },
  computed: {
    rememberedFirstName() {
      const rememberedString = this.$auth.remember();
      if (rememberedString) {
        const rememberedData = JSON.parse(rememberedString);
        if (rememberedData.firstName) {
          return rememberedData.firstName;
        }
      }
    },
    rememberedEmailAddress() {
      const rememberedString = this.$auth.remember();
      if (rememberedString) {
        const rememberedData = JSON.parse(rememberedString);
        if (rememberedData.email && rememberedData.email.address) {
          return rememberedData.email.address;
        }
      }
    }
  },
  created() {
    // set this.model.email to rememberedEmailAddress if available
    if (this.rememberedEmailAddress) {
      this.model.email = this.rememberedEmailAddress; // set to data prop
    }
  },
  methods: {
    forgetAuth: function() {
      if (
        this.rememberedEmailAddress &&
        this.rememberedEmailAddress === this.model.email
      ) {
        this.model.email = "";
      }
      this.$auth.unremember();
    },
    login: function() {
      // this will be called only after form is valid. You can do api call here to login
      this.loggingIn = true;
      this.errorMessage = null; // reset it

      let redirect = "/";

      if (this.$route.query.redirect) {
        redirect = this.$route.query.redirect;
      }

      this.$auth
        .login({
          data: {
            emailAddress: this.model.email,
            password: this.model.password
          },
          staySignedIn: this.model.staySignedIn,
          redirect
        })
        .then(result => {
          this.loggingIn = false;
        })
        .catch(error => {
          this.loggingIn = false;
          this.errorMessage = `Error logging in: ${error.response.statusText}`;
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
